export default __webpack_public_path__ + "static/media/img_03.935d5293.jpg";